// Mirror of backend DEFAULT_CONTENT — used as initial state so the UI renders
// instantly before /api/content resolves. The server always returns a complete
// (merged) object, which then replaces this.
export const DEFAULT_CONTENT = {
  hero: {
    overline: "A curated public archive · Est. MMXXVI",
    title_line1: "The Private",
    title_line2: "Library of",
    highlight: "Tirthak Saha",
    subtitle:
      "Favourite books, films, series, videos and essays — collected, annotated, and arranged into pathways for teaching yourself the classical fields.",
    bg_image:
      "https://images.unsplash.com/photo-1535905313417-483b22cb9d03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    bg_focal: { x: 50, y: 50, zoom: 1, veil: 0 },
    height: "full",
  },
  manifesto: {
    label: "The Manifesto",
    items: [
      { n: "01", t: "Purpose", b: "This is not an algorithm's idea of what you might like. It is a private record made public — the works that changed how I read, watch, and think, kept in one place so they might do the same for you." },
      { n: "02", t: "Curation", b: "Nothing here is comprehensive and nothing is neutral. Each entry earned its place by being returned to. A short note explains why it stayed, and a single link sends you to buy, read, or watch it." },
      { n: "03", t: "Method", b: "Beyond the catalogue sit Personal Curriculums: ordered pathways through philosophy, physics, art history and literature — designed so a curious beginner can teach themselves the shape of a field, one work at a time." },
    ],
  },
  picks: {
    label: "Picks of the Month",
    heading_line1: "Currently on",
    heading_line2: "the table",
    blurb: "A small, rotating spotlight on the books and films occupying my attention right now.",
  },
  flawed_prophets: {
    label: "From the Curator · A Book",
    title_line1: "Flawed",
    title_line2: "Prophets",
    description:
      "My own book — on the long, error-strewn human habit of predicting the future, and how understanding our failed prophecies can help us think about tomorrow with a little more humility.",
    amazon_url: "https://www.amazon.in/Flawed-Prophets-predicting-future-better/dp/B09BCC9DLK",
    goodreads_url: "https://www.goodreads.com/book/show/58757318-flawed-prophets",
    image: "https://images.unsplash.com/photo-1419640303358-44f0d27f48e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  footer: {
    book_link_label: "Flawed Prophets",
    book_link_url: "https://www.goodreads.com/book/show/58757318-flawed-prophets",
    tagline: "Reading · Watching · Thinking · Learning",
  },
  marquee: {
    words: ["Reading", "Watching", "Thinking", "Learning", "Returning"],
  },
  nav: {
    library: { title: "The Library", blurb: "Every entry, organized by medium. Browse and follow outbound links to buy, read, or watch." },
    curriculums: { title: "Personal Curriculums", blurb: "Ordered learning pathways through classical fields. Follow a sequence and track your progress." },
    order: ["library", "curriculums"],
  },
  pages: {
    library: {
      image: "https://images.unsplash.com/photo-1625053376622-e462848c453f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
      focal: { x: 50, y: 50, zoom: 1, veil: 0 },
      hero_height: "standard",
      overline: "The Collection",
      title_line1: "The",
      title_line2: "Library",
      subtitle: "The complete collection of books and essays. Browse everything, or narrow with the filters below.",
      overline_color: "crimson",
    },
    curriculums: {
      image: "https://images.unsplash.com/photo-1698433837319-c17f098c7895?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
      focal: { x: 50, y: 50, zoom: 1, veil: 0 },
      hero_height: "standard",
      overline: "Learning Pathways · Sign in to track progress",
      title_line1: "Personal",
      title_line2: "Curriculums",
      subtitle: "Ordered collections of works — books, films, videos and essays — arranged to teach yourself the basics of a classical field. Follow each pathway in sequence and check off what you complete.",
      overline_color: "crimson",
    },
  },
  spacing: {},
};
